/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_LiveInputs */

const en_link_editor_live = /** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const es_link_editor_live = /** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo`)
};

const fr_link_editor_live = /** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En ligne`)
};

const de_link_editor_live = /** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

/** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */
const ja_link_editor_live = en_link_editor_live;

/** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */
const zh_link_editor_live = en_link_editor_live;

/** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */
const ar_link_editor_live = en_link_editor_live;

/** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */
const id_link_editor_live = en_link_editor_live;

/** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */
const it_link_editor_live = en_link_editor_live;

/** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */
const ru_link_editor_live = en_link_editor_live;

/** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */
const pt_link_editor_live = en_link_editor_live;

/** @type {(inputs: Link_Editor_LiveInputs) => LocalizedString} */
const ko_link_editor_live = en_link_editor_live;

/**
* | output |
* | --- |
* | "Live" |
*
* @param {Link_Editor_LiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_live = /** @type {((inputs?: Link_Editor_LiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_LiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_live(inputs)
	if (locale === "es") return es_link_editor_live(inputs)
	if (locale === "fr") return fr_link_editor_live(inputs)
	if (locale === "de") return de_link_editor_live(inputs)
	if (locale === "ja") return ja_link_editor_live(inputs)
	if (locale === "zh") return zh_link_editor_live(inputs)
	if (locale === "ar") return ar_link_editor_live(inputs)
	if (locale === "id") return id_link_editor_live(inputs)
	if (locale === "it") return it_link_editor_live(inputs)
	if (locale === "ru") return ru_link_editor_live(inputs)
	if (locale === "pt") return pt_link_editor_live(inputs)
	return ko_link_editor_live(inputs)
});